// extracted by mini-css-extract-plugin
export var dataCell = "_ib-2";
export var dataRow = "_ib-0";
export var headerRow = "_ib-1";